import CustomDomainPage from "../CustomDomain/CustomDomainPage";

export default CustomDomainPage;
